/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _formMessage = __webpack_require__(334);
	
	var _formMessage2 = _interopRequireDefault(_formMessage);
	
	var _googleMap = __webpack_require__(404);
	
	var _googleMap2 = _interopRequireDefault(_googleMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Constants
	
	// Dependencies
	var googleMapConfig = {
	  backgroundColor: '#faf9f3',
	  center: {
	    lat: 30,
	    lng: 10
	  },
	  clickableIcons: false,
	  disableDefaultUI: true,
	  disableDoubleClickZoom: true,
	  scaleControl: false,
	  scrollwheel: false,
	  styles: [{
	    featureType: 'all',
	    stylers: [{
	      color: '#faf9f3'
	    }]
	  }, {
	    featureType: 'landscape',
	    elementType: 'geometry',
	    stylers: [{
	      color: '#212322'
	    }]
	  }, {
	    featureType: 'landscape',
	    elementType: 'labels',
	    stylers: [{
	      visibility: 'off'
	    }]
	  }, {
	    featureType: 'administrative.country',
	    elementType: 'labels',
	    stylers: [{
	      visibility: 'off'
	    }]
	  }],
	  zoom: 2,
	  zoomControl: false
	};
	
	// Components
	
	var googleMap = new _googleMap2.default(document.getElementById('clients-map'), googleMapConfig);
	
	google.maps.event.addDomListener(window, 'load', googleMap.init);

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formMessage;
	function formMessage(form, messageBody) {
	  var wrapper = document.createElement('DIV');
	
	  wrapper.className = 'form-message';
	  wrapper.innerHTML = messageBody;
	
	  form.parentNode.replaceChild(wrapper, form);
	};

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GoogleMap = function () {
	  function GoogleMap(root, config) {
	    _classCallCheck(this, GoogleMap);
	
	    this.root = root;
	    this.config = config;
	    this.googleMap = null;
	    this.points = null;
	
	    this.init = this.init.bind(this);
	    this.handleResize = this.handleResize.bind(this);
	  }
	
	  _createClass(GoogleMap, [{
	    key: 'handleResize',
	    value: function handleResize() {
	      google.maps.event.trigger(this.googleMap, 'resize');
	      this.googleMap.setCenter(this.config.center);
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      this.googleMap = new google.maps.Map(this.root, this.config);
	
	      google.maps.event.addDomListener(window, 'resize', this.handleResize);
	
	      this.points = window.hopkinsClientLocations.map(function (location) {
	        return new google.maps.Marker({
	          position: {
	            lat: parseFloat(location.lat),
	            lng: parseFloat(location.lng)
	          },
	          icon: '/assets/images/map-marker.svg',
	          map: _this.googleMap
	        });
	      });
	    }
	  }]);
	
	  return GoogleMap;
	}();
	
	exports.default = GoogleMap;
	;

/***/ })

/******/ });


// WEBPACK FOOTER //
// clients.js